import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/app/ui/assets/ocbc-illustration/lionparcel-ocbc-illustration.svg'
import _imports_1 from '@/app/ui/assets/svg/x-red.svg'


const _hoisted_1 = {
  style: {"height":"37rem"},
  class: "relative bg-white text-gray-lp-300 max-w-full flex-col flex rounded-lg"
}
const _hoisted_2 = { class: "flex flex-no-wrap h-full" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"350px"},
  class: "relative rounded-l-lg bg-red-lp-100 h-full m-auto flex flex-col justify-center"
}, [
  /*#__PURE__*/_createVNode("img", {
    class: "mx-auto",
    src: _imports_0,
    alt: "ocbcxlionparcel"
  })
], -1)
const _hoisted_4 = {
  style: {"width":"590px"},
  class: "relative"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "inline-flex justify-between w-full" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-20px font-semibold px-6 pt-10 py-6" }, [
    /*#__PURE__*/_createTextVNode(" Dapatkan limit pinjaman"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("sampai dengan Rp 200.000.000 ")
  ])
], -1)
const _hoisted_6 = { class: "px-6" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"text-12px xxl:text-14px\"> Lion Parcel bekerja sama dengan Bank OCBC NISP memberikan solusi pembiayaan modal kerja Anda, tenor 1 minggu sampai dengan 3 bulan dengan bunga 0% dan biaya provisi mulai dari 1%. </div><div class=\"text-12px mt-3\"><div class=\"font-semibold\"> Bagaimana simulasinya? </div><div class=\"font-normal mt-2\"><ul class=\"list-disc pl-6\"><li> POS A meminjam Rp 5.000.000 untuk tenor 2 minggu. Saat pencairan, POS A akan menerima uang dalam bentuk saldo POS sebesar Rp 4.950.000 dari Bank OCBC NISP. </li></ul></div></div><div class=\"text-12px mt-3\"><div class=\"font-semibold\"> Berapa nominal pencairan? </div><div class=\"font-normal mt-2\"><ul class=\"list-disc pl-6\"><li> Limit – Biaya Provisi<br>Rp 5.000.000 – (1% * Rp 5.000.000)<br>Rp 4.950.000 </li></ul></div></div><div class=\"text-12px mt-3\"><div class=\"font-semibold\"> Berapa nominal pembayaran? </div><div class=\"font-normal mt-2\"><ul class=\"list-disc pl-6\"><li> Saat jatuh tempo, POS A wajib melakukan pembayaran kepada Bank OCBC NISP sebesar Rp 5.000.000. </li></ul></div></div><div class=\"text-12px mt-3\"><div class=\"font-semibold\"> Ketentuan </div><div class=\"font-normal mt-2\"><ul class=\"list-disc pl-6\"><li> Proses hanya 2-3 hari kerja. </li><li> Berlaku untuk seluruh wilayah mitra POS Lion Parcel. </li></ul></div></div>", 5)
const _hoisted_12 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        ref: "modal",
        tabindex: "0",
        onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)), ["esc"])),
        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)), ["self"])),
        class: "justify-center items-center flex bg-overlay fixed inset-0 z-50 overflow-hidden"
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode("div", _hoisted_4, [
              _createVNode("img", {
                src: _imports_1,
                class: "w-6 cursor-pointer absolute",
                style: {"top":"1.5rem","right":"1.5rem"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.forceCloseDialog && _ctx.forceCloseDialog(...args))),
                alt: "x"
              }),
              _hoisted_5,
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_lp_button, {
                    class: "mt-8 w-auto",
                    title: "Daftar Sekarang",
                    "text-color": "white",
                    color: "red-lp-100",
                    "custom-class": "px-12",
                    rounded: "",
                    onClick: _ctx.registerNow
                  }, null, 8, ["onClick"])
                ])
              ])
            ])
          ])
        ])
      ], 544))
    : _createCommentVNode("", true)
}